import { QueryClient } from 'react-query'

export const contentDetailsPromise = async (
  queryClient: QueryClient,
  id: number,
  toEnrollment: boolean = false
) => {
  const module = await import('@remote/content/remote-user-content-details-factory')
  const make = module.makeRemoteUserContentDetails
  const remote = make(queryClient)
  return await remote.get(id, toEnrollment)
}

export const enrollmentContentInfoPromise = async (
  queryClient: QueryClient,
  id: number,
  toEnrollment: boolean = false
) => {
  const module = await import(
    '@remote/content/enrollment/remote-user-enrollment-content-info-factory'
  )
  const make = module.makeRemoteUserEnrollmentContentInfo
  const remote = make(queryClient)
  return await remote.get(id, toEnrollment)
}
